export class Request {
    id: number = 0;
    clientId: string = "";
    status: string = "";
    negRef: string = "";
    corporateName: string = "";
    cnpj: string = "";
    dealer: string = "";
    dealerCod: string = "";
    modalityId: string = ""; 
    modality: string = "";
    model: string = "";
    modelId: string = "";
    frontOffice: string = "";
    userFof: string = "";
    neg: string = "";
    manager: string = "";
    total: string = "";
    forecast: string = "";
    modfat: string = "";
}

